var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h2',{staticClass:"text-center"},[_vm._v(" Trellis is currently in maintenance mode and will return shortly. ")]),_c('p',{staticClass:"mt-2 text-center"},[_vm._v(" Please check back in a few minutes or wait for this page to automatically reload when Trellis has returned. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }